import { loadFeedConfigMappings } from "@/v2/kits/feed-mapping";
import type { FeedConfigDialogApi } from "../types";

type EntityMappingsClient = {
  getFeedTypeMappings: (
    entityId: string | number,
    filters?: Record<string, unknown>,
  ) => Promise<unknown>;
  getFeedInstanceMappings: (
    entityId: string | number,
    filters?: Record<string, unknown>,
  ) => Promise<unknown>;
  updateEntity: FeedConfigDialogApi["updateEntity"];
};

export function createFeedConfigDialogApi(
  resolveEntityId: FeedConfigDialogApi["resolveEntityId"],
  client: EntityMappingsClient,
): FeedConfigDialogApi {
  return {
    resolveEntityId,
    loadMappings: (entityId, options) => loadFeedConfigMappings(client, entityId, options),
    updateEntity: async (entityId, payload) => {
      await client.updateEntity(entityId, payload);
    },
  };
}
